import { IconButton } from "@material-ui/core";
import { Add, Remove } from "@material-ui/icons";
import { InnerLabelTextfield, TextField } from "components/commons";
import React from "react";
import {
  DECIMAL_PLACES,
  FieldKind,
  formatByKind,
  MAX_COUNT,
  MAX_INTEGER_DIGITS,
  toNumber,
} from "./account-type-vip-tiers.utils";
import styles from "./account-type-vip-tier-inputs.module.scss";

const INPUT_COLOR = "var(--color-blue-gray)";

export const TierNumberInput = ({ name, kind, value, onChange, error, disabled }) => {
  const PREFIX = {
    [FieldKind.Amount]: "₱",
    [FieldKind.Volume]: "L",
    [FieldKind.VolumeRate]: "L",
  };
  const maxDigits = name === "tierThresholdLiters" ? 12 : null;
  const pattern = new RegExp(
    `^\\d{0,${MAX_INTEGER_DIGITS}}(\\.\\d{0,${DECIMAL_PLACES[kind]}})?$`
  );
  const Input = PREFIX[kind] ? InnerLabelTextfield : TextField;

  return (
    <Input
      className={styles.numberInput}
      name={name}
      value={value}
      error={error}
      disabled={disabled}
      fontColor={INPUT_COLOR}
      prefix={PREFIX[kind]}
      onChange={(n, { value: raw }) => {
        const cleaned = raw.replace(/,/g, "");
        const withinDigits = !maxDigits || cleaned.replace(".", "").length <= maxDigits;
        if (pattern.test(cleaned) && withinDigits) {
          onChange(n, { value: cleaned });
        }
      }}
      onFocus={() => onChange(name, { value: String(value).replace(/,/g, "") })}
      onBlur={(n, { value: raw }) => onChange(n, { value: formatByKind(raw, kind) })}
    />
  );
};

export const CountStepper = ({ name, value, onChange, error, disabled }) => {
  const count = toNumber(value) ?? 0;
  const setCount = (next) =>
    onChange(name, { value: String(Math.min(Math.max(next, 0), MAX_COUNT)) });

  return (
    <div className={styles.stepper}>
      <IconButton
        className={styles.stepButton}
        size="small"
        disabled={disabled || count <= 0}
        onClick={() => setCount(count - 1)}
      >
        <Remove fontSize="inherit" />
      </IconButton>
      <div className={styles.stepValue}>
        <TextField
          name={name}
          value={value}
          error={error}
          disabled={disabled}
          fontColor={INPUT_COLOR}
          onChange={(n, { value: raw }) => {
            if (new RegExp(`^\\d{0,${MAX_INTEGER_DIGITS}}$`).test(raw)) {
              onChange(n, { value: raw });
            }
          }}
        />
      </div>
      <IconButton
        className={styles.stepButton}
        size="small"
        disabled={disabled || count >= MAX_COUNT}
        onClick={() => setCount(count + 1)}
      >
        <Add fontSize="inherit" />
      </IconButton>
    </div>
  );
};
